<div [class]="this.getCustomPostionClass()">
    <div class="loading">
      <div class="bounceball"></div>
      <div class="text">{{this.getLoadingMessage()}}</div>
    </div>
</div>